<template>
  <vxe-grid
    ref="vxeGrid"
    auto-resize
    highlight-hover-row
    :data="tableData"
    :columns="tableColumns"
    :toolbar-config="tableToolbar"
    :loading="loading"
    :height="350"
    size="mini"
    resizable
    border
    :radio-config="{highlight: true, trigger: 'row', strict: false}"
    :checkbox-config="{
      highlight: true,
      reserve: true,
    }"
    @radio-change="radioChange"
  >
    <template v-slot:toolbar_form>
      <slot name="header">
        <div class="side-frame-success">
          <span class="side-frame-text">
            {{ '可选订舱记录' }}
          </span>
        </div>
      </slot>
    </template>
    <template v-slot:batchAmount="{row}">
      <span>{{ row.v_batchPriceAmount || 0 }} {{ row.v_currencyUnit }}</span>
    </template>
    <template v-slot:batchSalePrice="{row}">
      <span
        >{{ row.v_batchSalePriceAmount || 0 }}
        {{ row.v_salesCurrencyUnit }}</span
      >
    </template>
    <template v-slot:empty="{}">
      <div style="text-align: center">
        <img src="/image/static/img/nodata.png" />
        <p class="no-data mt-2">
          {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
        </p>
      </div>
    </template>
  </vxe-grid>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: {type: Array, default: () => []},
    loading: {type: Boolean, default: false},
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    choiceData() {
      return this.getRadioRecord()
    },
    getRadioRecord() {
      const data = this.$refs.vxeGrid.getRadioRecord()
      if (!data) {
        this.$message({
          showClose: true,
          message:
            this.$l('INDEX.table_label_pl_select_add_data') ||
            '请选择需要添加的数据',
          type: 'warning',
        })
        return
      }
      return data
    },
    radioChange() {
      const data = this.$refs.vxeGrid.getRadioRecord()
      this.$emit('radioChange', data)
    },
  },
}
</script>
